export { default as Header } from './header'
export { default as Menu } from './menu'
export { default as HomeHero } from './homeHero'
export { default as HomeAbout } from './homeAbout'
export { default as HomeClients } from './homeClients'
export { default as HomeService } from './homeService'
export { default as HomeWhy } from './homeWhy'
export { default as HomeProject } from './homeProject'
export { default as HomeAction } from './homeAction'
export { default as ServiceHero } from './serviceHero'
export { default as ServiceHeroTweaksAndChanges } from './serviceHeroTweaksAndChanges'
export { default as ServiceHeroConvertingHeroImages } from './ServiceHeroConvertingHeroImages'
export { default as ServiceHeroConvertingCollectionBanners } from './ServiceHeroConvertingCollectionBanners'
export { default as ServiceHeroNewsletterPopupsDesign } from './ServiceHeroNewsletterPopupsDesign'
export { default as ServiceHeroEmailHeaderDesign } from './ServiceHeroEmailHeaderDesign'
export { default as ServiceHeroConvertingNewsletterDesign } from './ServiceHeroConvertingNewsletterDesign'
export { default as ServiceHeroCustomIconDesign } from './ServiceHeroCustomIconDesign'
export { default as ServiceHeroBannerAdsThatConvert } from './ServiceHeroBannerAdsThatConvert'
export { default as ServiceHeroSocialMediaAdsThatConvert } from './ServiceHeroSocialMediaAdsThatConvert'
export { default as ServiceHeroSocialMediaCoverPhotos } from './ServiceHeroSocialMediaCoverPhotos'

export { default as ServiceHeroAdvancedCustomization } from './serviceHeroAdvancedCustomization'
export { default as ServiceHeroCustomDevelopment } from './serviceHeroCustomDevelopment'

export { default as ServiceDesign } from './serviceDesign'
export { default as ServiceEcommerce } from './serviceEcommerce'
export { default as ServiceMarketing } from './serviceMarketing'
export { default as ServiceLaunch } from './serviceLaunch'
export { default as ServiceSetup } from './serviceSetup'
export { default as ServicePricing } from './servicePricing'
export { default as ServiceExpert } from './serviceExpert'
export { default as ServiceContact } from './serviceContact'
export { default as Footer } from './footer'
